import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import FailedMedia from '../../../../ai-studio/components/failed-media/FailedMedia';

import scss from './Activ8Video.module.scss';

function Activ8Video({ src, poster, videoClassName, isExpired, lazy = false, onError }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  const hasSrc = !!src;
  const isLoading = (hasSrc || !!poster) && !isLoaded && !error;

  useEffect(() => {
    setIsLoaded(false);
    setError(false);
  }, [src, poster]);

  useEffect(() => {
    if (!src && !poster) {
      setError(true);
      onError?.();
    }
  }, [src, poster, onError]);

  const handleMediaReady = () => {
    setIsLoaded(true);
  };

  const handleLoadingError = () => {
    setError(true);
    onError?.();
  };

  if (!src && !poster) {
    return <FailedMedia />;
  }

  return (
    <>
      {!error ? (
        <video
          src={src || undefined}
          poster={poster || undefined}
          className={clsx(scss.video, videoClassName, isExpired && scss.disabled)}
          controls={hasSrc && !isExpired}
          controlsList={isExpired ? 'nodownload' : undefined}
          disablePictureInPicture={isExpired || undefined}
          preload={lazy ? 'metadata' : 'auto'}
          onLoadedMetadata={handleMediaReady}
          onLoadedData={hasSrc ? handleMediaReady : undefined}
          onError={handleLoadingError}>
          <track kind='captions' />
        </video>
      ) : null}
      {error ? <FailedMedia /> : null}
      <CommonLoader isLoading={isLoading} />
    </>
  );
}

export default Activ8Video;
